import estimates, { EstimateModel } from "./estimate";
import chat, { IChatModel } from "./chat";
import design, {DesignModel} from './design';
import order, {OrderModel} from "./orders";
import cart, { CartModel} from "./cart";

export interface StoreModel {
  estimstes: EstimateModel;
  chat: IChatModel;
  design: DesignModel
  order: OrderModel;
  cart: CartModel;
}

const model = {
  estimates,
  chat,
  design,
  order,
  cart
};

export default model;
